import {
	Accordion,
	AccordionSummary,
	AccordionDetails,
	IconButton,
} from '@mui/material';
import { styled } from '@mui/material/styles';

import React, { useEffect, useRef } from 'react';

import { ReactComponent as ExpandMoreIcon } from 'common/assets/images/downchevron.svg';

import styles from './AccordianComp.module.scss';

const { accordionDisabledBg, accordianWhiteBg } = styles;

const StyledAccordion = styled(Accordion)(() => ({
	'& .MuiAccordionSummary-content.Mui-expanded': {
		margin: '12px 0',
	},
	'& .MuiAccordionSummary-root.Mui-expanded': {
		minHeight: '48px',
	},
	'&.Mui-disabled': {
		backgroundColor: accordionDisabledBg,
	},
}));

interface IAccordionProps {
	className?: string;
	summary: React.ReactNode;
	details: React.ReactNode;
	detailsStyle?: string;
	parentDivStyle?: string;
	expanded?: boolean;
	onChange?: (event: React.SyntheticEvent, isExpanded: boolean) => void;
	multipleExpand?: boolean;
	isFocusVisible?: boolean;
	isLeftAccordian?: boolean;
	isScrollNeeded?: boolean;
	dataTestId?: string;
	disabled?: boolean;
}

const defaultProps = {
	className: undefined,
	expanded: false,
	multipleExpand: false,
	isLeftAccordian: false,
	isFocusVisible: false,
	dataTestId: undefined,
};

const AccordionComp = (props: IAccordionProps) => {
	const {
		className,
		summary,
		details,
		expanded,
		onChange,
		multipleExpand,
		isScrollNeeded,
		isLeftAccordian,
		dataTestId,
		disabled,
		detailsStyle,
		parentDivStyle,
		isFocusVisible,
	} = props;
	const accordionRef = useRef<any>();
	const executeScroll = () => accordionRef?.current?.scrollIntoView();

	useEffect(() => {
		if (isScrollNeeded) {
			executeScroll();
		}
	}, [isScrollNeeded]);

	return (
		<div
			ref={accordionRef}
			data-testid="accordion-details"
			className={parentDivStyle}
		>
			{multipleExpand ? (
				<StyledAccordion
					disabled={disabled}
					className={className}
					sx={{
						'& .Mui-focusVisible': isFocusVisible
							? {
									backgroundColor: `${accordianWhiteBg} !important`,
							  }
							: {},
					}}
				>
					<AccordionSummary
						className={
							isLeftAccordian
								? styles['accordian-row-reverse']
								: styles['accordian-row']
						}
						onClick={(event) => onChange && onChange(event, !expanded)}
						data-testid={dataTestId}
						expandIcon={
							<IconButton
								className={styles['expand-icon-size']}
								data-testid={dataTestId}
							>
								<ExpandMoreIcon className={styles['expand-icon-style']} />{' '}
							</IconButton>
						}
					>
						{summary}
					</AccordionSummary>
					<AccordionDetails>{details}</AccordionDetails>
				</StyledAccordion>
			) : (
				<StyledAccordion
					disabled={disabled}
					className={className}
					expanded={expanded}
					sx={{
						'& .Mui-focusVisible': isFocusVisible
							? {
									backgroundColor: `${accordianWhiteBg} !important`,
							  }
							: {},
					}}
				>
					<AccordionSummary
						className={
							isLeftAccordian
								? styles['accordian-row-reverse']
								: styles['accordian-row']
						}
						onClick={(event) => onChange && onChange(event, !expanded)}
						data-testid={dataTestId}
						expandIcon={
							<IconButton className={styles['expand-icon-size']}>
								{' '}
								<ExpandMoreIcon />{' '}
							</IconButton>
						}
					>
						{summary}
					</AccordionSummary>
					<AccordionDetails className={detailsStyle}>
						{details}
					</AccordionDetails>
				</StyledAccordion>
			)}
		</div>
	);
};

export default AccordionComp;

AccordionComp.defaultProps = defaultProps;
